import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { frames, useMediaQuery } from "../../../../Styles";
import { PageHeader, NewInput, GroupCard, NewModal, MainContentPaddingTypes, Overlay } from '../../../../Components';
import { ButtonTypes, NewInputHandles } from '../../../../Definitions';
import { useAppSelector } from '../../../../Store';
import { Graph_QL } from '../../../../Services';
import { useAnimalGroups } from '../../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimalGroups';
import { Pages } from '../../../../Navigation/root';
import CardsView from '../../../../Assets/TestData/cardsView';
import NewButton from '../../../../Components/BaseComponents/newButton';

export default function AnimalsGroups() {
  const { t } = useTranslation();
  const [addGroupModal, setAddGroupModal] = useState<boolean>(false)
  const [deleteGroupMode, setDeleteGroupMode] = useState(false)
  
  const [groupsForDeletion, setGroupsForDeletion] = useState<number[]>([])

  const animalGroupNameInputRef = useRef<NewInputHandles>(null);

  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);;
  
  const { call: getAnimalGroups, data: animalGroupsState, maintainEntries: createAnimalGroups, deleteAnimalGroups } = useAnimalGroups(connection);

  useEffect(() => {
    getAnimalGroups({fetchAmount: 50, ifIncludeAnimalCount: true})
  },[])

  const groupData = useMemo(() => {
    if (animalGroupsState && animalGroupsState[domain]) {
      return animalGroupsState[domain].data
    }
    return []
  },[animalGroupsState, domain])

  const addGroupModalComponent = (
    <NewModal
      modalState={!!addGroupModal}
      overrides={{ 
        mainContentPadding: MainContentPaddingTypes.secondary
      }}
      predefinedButtons={{
        onClose: () => setAddGroupModal(false)
      }}
      header={t("animalPages.animalGroups.newGroup", {defaultValue: "New Group"})}
      mainContent={<NewInput ref={animalGroupNameInputRef} header={t("animalPages.animalGroups.groupName", { defaultValue: "group name" })} />}
      footerContent={<NewButton
        content={t("animalPages.animalGroups.createGroup", {defaultValue: "create group"})}
        buttonType={ButtonTypes.primaryButton}
        overrides={{
          baseStyles: {width: "fit-content"}
        }}
        onClick={() => {
          if (animalGroupNameInputRef.current?.value && createAnimalGroups) {
            createAnimalGroups({data: [{name: animalGroupNameInputRef.current.value}]})
          }
          setAddGroupModal(false);
        }}
      />}
    />
  )
  
  return (
    <frames.Page_inner>
      <PageHeader
        topHeader={t(`menuHeaders.${Pages.animals}`, { defaultValue: "animals" })}
        subHeader={t(`menuHeaders.${Pages.animalsGroups}`, { defaultValue: "animal groups" })}
        optionButtons={{
          contents: deleteGroupMode ? ["save", t("buttons.cancel", {defaultValue: "cancel"})] : ["Delete group"],
          onClick: deleteGroupMode ? (i => { 
            if (i === 0) {setDeleteGroupMode(false); deleteAnimalGroups(groupsForDeletion); setGroupsForDeletion([]);}
            if (i === 1) {setDeleteGroupMode(false); setGroupsForDeletion([]);}
          }) : (i => {
            if (i === 0) { setDeleteGroupMode(true) }
          })       
        }}
      />
      <frames._page_inner_content_scroll>
        {deleteGroupMode ? <Overlay overrides={{ zIndex: 9999 }} /> : <></>}
        <div style={{ zIndex: deleteGroupMode ? "99999" : "auto", position: deleteGroupMode ? "relative" : "unset" }}>
          <CardsView
            items={groupData.filter((item) => !groupsForDeletion.includes(item.animal_group_id)).map((item, index) => (
              <GroupCard
                key={index}
                selectedGroup={item}
                onClick={deleteGroupMode ? () => {setGroupsForDeletion((old) => { return [...old, item.animal_group_id] }) } : undefined}
              />
            ))}
            cardBtn={{
              content: t("animalPages.animalGroups.createGroup", {defaultValue: "create group"}),
              onCardBtnClick: () => { setAddGroupModal(true) },
              height: "50px"
            }}
          />
        </div>
      </frames._page_inner_content_scroll>
    
    {addGroupModalComponent}
    </frames.Page_inner>
  )
}